import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import "./Legal.scss"

export const PrivacyPolicyPage = () => {

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-component="PrivacyPolicyPage">
        <main className="legal">

          <h2>Privacy Policy</h2>
          <p><strong>Last Updated:</strong> Nov 27, 2024</p>


          <p><strong>Hamilton Zell LLC</strong> ("we," "us," "our") is committed to protecting your privacy. This Privacy Policy outlines our practices regarding the collection, use, and disclosure of personal information when you use <strong>Practice Run AI</strong> ("the App").</p>

          <h3>1. Information We Collect</h3>
          <ul>
              <li><strong>Account Information:</strong> When you sign up, we collect your LinkedIn profile information to create your account and authenticate your identity.</li>
              <li><strong>Interview Data:</strong> We record and log your practice interview sessions to generate performance reviews. This information is securely stored and is only used for the purposes described in this policy.</li>
              <li><strong>Analytics Data:</strong> We use Google Analytics to monitor site traffic, understand user interactions, and optimize our services. Google Analytics collects data such as IP address, device type, browser, and pages visited.</li>
          </ul>

          <h3>2. How We Use Your Information</h3>
          <ul>
              <li><strong>To Provide Services:</strong> We use your account information and interview data to personalize your practice interview experience and create performance review reports.</li>
              <li><strong>Analytics and Improvements:</strong> We analyze user interactions through Google Analytics to improve the App, understand user behavior, and measure conversion rates.</li>
          </ul>

          <h3>3. Sharing and Disclosure of Information</h3>
          <ul>
              <li><strong>Third-Party Services:</strong> We share limited information with third-party services, such as Google Analytics, strictly for analytics and service improvement.</li>
              <li><strong>Compliance with Laws:</strong> We may disclose information if required by law, legal process, or governmental request.</li>
          </ul>

          <h3>4. Data Security</h3>
          <p>We take data security seriously and implement industry-standard measures to protect your information. However, no system can be 100% secure. By using the App, you acknowledge that we cannot guarantee absolute security.</p>

          <h3>5. Data Retention</h3>
          <p>We retain interview data for as long as necessary to provide our services or as required by law. If you delete your account, we will delete your personal information and interview data.</p>

          <h3>6. Your Rights</h3>
          <ul>
              <li><strong>Access and Correction:</strong> You can access and update your account information within the App.</li>
              <li><strong>Data Deletion:</strong> You can request data deletion by contacting our support team at support@practicerun.ai</li>
          </ul>

          <h3>7. Changes to This Privacy Policy</h3>
          <p>We may update this policy to reflect changes in our practices. We encourage you to review this Privacy Policy periodically.</p>

          <p><strong>Contact Us</strong><br />If you have any questions about this Privacy Policy, please contact us at support@practicerun.ai</p>


      </main>
    </div>
  );
};